export default __webpack_public_path__ + "static/media/foudner.132ef11f.png";